'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _icons = require('icons/icons');

var icons = _interopRequireWildcard(_icons);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _UINotificationBadge = require('UIComponents/badge/UINotificationBadge');

var _UINotificationBadge2 = _interopRequireDefault(_UINotificationBadge);

var _WidgetHeaderButton = require('../WidgetHeaderButton');

var _WidgetHeaderButton2 = _interopRequireDefault(_WidgetHeaderButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShowThreadListButton = function (_React$PureComponent) {
  _inherits(ShowThreadListButton, _React$PureComponent);

  function ShowThreadListButton() {
    _classCallCheck(this, ShowThreadListButton);

    return _possibleConstructorReturn(this, (ShowThreadListButton.__proto__ || Object.getPrototypeOf(ShowThreadListButton)).apply(this, arguments));
  }

  _createClass(ShowThreadListButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          unseenThreadsCountExcludingCurrentThread = _props.unseenThreadsCountExcludingCurrentThread,
          showThreadList = _props.showThreadList,
          style = _props.style;


      return _react2.default.createElement(
        _UINotificationBadge2.default,
        {
          badgeClassName: 'unseen-badge',
          className: (0, _classNames2.default)('show-threads-wrapper', this.props.mobile ? 'p-bottom-6' : 'p-top-6'),
          placement: 'inline',
          badgeLabel: unseenThreadsCountExcludingCurrentThread,
          showBadge: !!unseenThreadsCountExcludingCurrentThread
        },
        _react2.default.createElement(_WidgetHeaderButton2.default, {
          className: 'selenium-test-marker-show-threads-button p-top-6',
          style: style,
          iconName: icons.LEFT,
          onClick: showThreadList
        })
      );
    }
  }]);

  return ShowThreadListButton;
}(_react2.default.PureComponent);

exports.default = ShowThreadListButton;


ShowThreadListButton.propTypes = {
  mobile: _react.PropTypes.bool.isRequired,
  showThreadList: _react.PropTypes.func.isRequired,
  style: _react.PropTypes.object,
  unseenThreadsCountExcludingCurrentThread: _react.PropTypes.number.isRequired
};

ShowThreadListButton.defaultProps = {
  mobile: false
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/components/ShowThreadListButton.js
// module id = 1055
// module chunks = 2 3